import { FeatureFlagKey } from "@redotech/feature-flags-model";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { createContext, memo, type ReactNode } from "react";

const CodeSearchFeatureFlagContext = createContext<boolean | undefined>(
  undefined,
);

export function useCodeSearchFeatureFlag(): boolean {
  return useRequiredContext(CodeSearchFeatureFlagContext);
}

export const CodeSearchFeatureFlagProvider = memo(
  function CodeSearchFeatureFlagProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const platformRpcClient = useRequiredContext(
      RedoPlatformAuthRpcClientContext,
    );

    const codeSearchEnabledLoad = useLoad(async () => {
      const response = await platformRpcClient
        .getFeatureFlag({ flagKey: FeatureFlagKey.ASK_REDO_CODE_SEARCH })
        .catch(() => ({ enabled: false }));

      return { platformRpcClient, enabled: response.enabled };
    }, [platformRpcClient]);

    const codeSearchEnabledResult = codeSearchEnabledLoad.value;

    if (
      codeSearchEnabledLoad.pending ||
      codeSearchEnabledResult?.platformRpcClient !== platformRpcClient
    ) {
      return null;
    }

    return (
      <CodeSearchFeatureFlagContext.Provider
        value={codeSearchEnabledResult.enabled}
      >
        {children}
      </CodeSearchFeatureFlagContext.Provider>
    );
  },
);
